import { Environment } from '@thiememeulenhoff/types';
import { OneGateEnvironmentType } from './environment.type';

export const environment: OneGateEnvironmentType = {
  environment: Environment.Production,
  production: true,
  backendUrl: 'https://onegate.thiememeulenhoff.nl/api/',
  editionFallbackUrl: 'https://edition.thiememeulenhoff.nl/secure/next',
  toegangSso: {
    authUrl: 'https://idp.toegang.org/oidc/auth',
    clientId: 'NT2',
    silentRedirectUri: 'https://onegate.thiememeulenhoff.nl/silent-callback',
  },
};
